import React from 'react'
import { WellnessHubHeading } from '../../containers/Education/styles'
import { BackArrowFeed, EditIconNew } from '../../utils/icons'
import {  useHistory,useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect } from 'react';
import { fetchApi } from '../../utils/methods';
import { GetLaunchedArticle, GetLaunchedFitness, GetLaunchedRecipe } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import { FlexWrapper, NewChampionsCardNew,EventCard, NewVideoPlayerNew, NewContentV2New} from '../MainEvents/RecommendEventVideos/styles'
import Thumbnail from '../Thumbnail';
import {ImageUrl} from '../../utils/constants';
import { NoText } from './style';

function CategoryContentComponent() {
  const history = useHistory();
  const location = useLocation();
  const [categoryContent, setCategoryContent] = React.useState([]);
  const [conetentLoading, setContentLoading] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [hasMore, setHasMore] = React.useState(true);
  const categoryData = location.state?.categoryData;
  const contentType = location.state?.contentType;


  if (!categoryData || !contentType) {
    history.replace("/company/wellness");
    return null; // ⛔ stop rendering this component
  }



  // useEffect(()=>{
  //   FetchRecentLaunchedData();
  // },[contentType, categoryData])


  useEffect(() => {
    setCategoryContent([]);
    setPage(1);
    setHasMore(true);
    FetchRecentLaunchedData(1);
  }, [contentType, categoryData]);


  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (
  //       window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 &&
  //       hasMore &&
  //       !conetentLoading
  //     ) {
  //       FetchRecentLaunchedData(page + 1);
  //     }
  //   };
  
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [page, hasMore, conetentLoading]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 &&
        hasMore &&
        !conetentLoading
      ) {
        FetchRecentLaunchedData(page);
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, hasMore, conetentLoading]);
  


  const API_BY_TYPE = {
    articles: GetLaunchedArticle,
    fitness: GetLaunchedFitness,
    recipes: GetLaunchedRecipe  
  };


  const FetchRecentLaunchedData = async(pageNumber = 1)=>{
    if (!hasMore || conetentLoading) return;

    const category_id = categoryData?.id;
    const limit = 10;
    const order ="desc";
    const apiUrl = API_BY_TYPE[contentType];
    // const page = page
    setContentLoading(true);

   
    try {
      const url =
        `${apiUrl}?limit=${limit}&order=${order}&category_id=${category_id}&page=${pageNumber}`;
      const res = await fetchApi(url,"GET");
      if(res.status === 'success'){
        // setCategoryContent(res.data[0].data)
        // setContentLoading(false);
        const pageData = res.data[0];

        // setCategoryContent((prev) =>
        //   pageNumber === 1 ? pageData.data : [...prev, ...pageData.data]
        // );

        // setCategoryContent((prev) => [...prev, ...pageData.data]);


        setCategoryContent((prev) =>
          pageNumber === 1 ? pageData.data : [...prev, ...pageData.data]
        );

        if (pageData.current_page >= pageData.last_page) {
          setHasMore(false);   // 🛑 stop fetching
        } else {
          setPage((prev) => prev + 1); // move to next page
        }
       
      }else{
        toast.error((res?.data?.message))
       
      }
    } catch (error) {
      window.console.error(error);
    }
    finally {
      setContentLoading(false);
    }
  }



  const handleCardClick = (item) => {

    if (contentType === "articles")
      history.push(`/wellness-resources/article-details/${item.article_id}`);
    else if (contentType === "fitness")
      history.push(`/wellness-resources/fitness-details/${item.fitness_id}`);
    else if (contentType === "recipes")
      history.push(`/wellness-resources/recipe-details/${item.recipe_id}`);
  };


  const handleEdit = (id) => {
    if (contentType === "articles")
      history.push({pathname:`/wellness-resources/edit-article/${id}`})
    else if (contentType === "recipes")
      history.push({
        pathname: `/wellness-resources/edit-recipe/${id}`
      });
    else if (contentType === "fitness")
      history.push({
        pathname: `/education/videos-library/edit/${id}`
      });
  }; 





  return (
    <div style={{maxWidth: "1246px", padding: "24px 0px 40px 0px",margin: "auto",width: "100%"}}>
      <WellnessHubHeading>
        <div className='right-row'>
          <div className="icon" onClick={() => history.push("/company/wellness", {
            activeTab: "Library",
            activeLibraryTab: contentType === "articles" ? "Articles" : contentType === "fitness" ? "Fitness" : "Recipes",
          })}>
            {BackArrowFeed("#DA6C74")}
          </div>
          <div className="title">{categoryData?.category_name || categoryData?.recipe_tag }</div>
        </div>
      </WellnessHubHeading>


      { categoryContent?.length || conetentLoading ? <FlexWrapper>
        {categoryContent
          .map((item) => (
            <NewChampionsCardNew key={item.article_id || item.recipe_id || item.fitness_id}>
              <EventCard isMarginBottom={"0px"} borderRadius={"6px 6px 0 0"}  isWidth={"398px"}>
                <NewVideoPlayerNew onClick={() => handleCardClick(item)}  style={{ cursor: 'pointer' }}>
                  <Thumbnail
                    style={{ cursor: 'pointer',marginTop:"8px"}} 
                    src={`${ImageUrl}/${item?.article_image || item?.recipe_image || item?.thumbnail_image}`}
                    alt={'img'}
                  />
                </NewVideoPlayerNew>
                <NewContentV2New newPadding={'newPadding'}  isPadding={"16px 8px 8px 8px"}  style={{ minHeight: 'auto',backgroundColor:"#FEFEFE",borderRadius:'0px 0px 8px 8px' }}>
                  <div className='firstContainer'>
                    <div className='name' title={item?.title}>
                      {item?.title}
                    </div>
                  </div>

                  <div className="imageContainer">
                    <span
                      className="icon edit"
                      onClick={() => handleEdit(item.article_id || item.recipe_id || item.fitness_id)}
                      title="Edit"
                    >
                      {EditIconNew()}
                    </span>
                  </div>
                </NewContentV2New>
              </EventCard>
            </NewChampionsCardNew>
          ))}
      </FlexWrapper> :
        <NoText>
          No content added for this category yet!
        </NoText>}

    </div>
  )
}



export default CategoryContentComponent;
